import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import moment from "moment";
import "ulysses/widgets/timeline/timeline";

"use strict";
var _row_templates = {};
$(document).ready(function() {
    $("[id*=chattimeline-row-]").each(function(){
        var $this = $(this);
        _row_templates[$(this).attr("id").replace("chattimeline-row-", "").replace("-tmpl", "")] = $this;
    });
});

var _id_min = 0;
function _generate_id() {
    return "tml_"+(++_id_min);
}

function update_facets(result, timeline_model) {
    var facets = [];
    var active = $.map(timeline_model.faceting.active(), function(v,idx) {
        return v.selector;
    });
    if (result.facets && result.facets.facet_fields) {
        $.each(result.facets.facet_fields, function(idx, facet) {
            var f = {
                "caption": facet.caption,
                "name": facet.name,
                "icon": facet.icon,
                "colour": facet.colour || "light-sea-green",
                "data": ko.observableArray($.map(facet.data, function(value, key) {
                    if (value.count) {
                        //ensure this is not already active
                        var selector = facet.name+":"+value.key;
                        if (active.indexOf(selector) < 0)
                            return { "key": value.key, "value": value.count, "caption": value.caption };
                    }
                    return null;
                }))
            };
            f.selectFacet = function(data, ev) {
                var selector = facet.name == "facet_queries" ? data.key : (facet.name + ":" + data.key);
                timeline_model.faceting.active.push({
                    "name": facet.name,
                    "value": data.key,
                    "valueCaption": data.caption,
                    "selector": selector,
                    "caption": facet.caption
                });
                f.data.remove(data);
                timeline_model.refresh();
            };
            facets.push(f);
        });
    }
    timeline_model.faceting.widgets(facets);
}
function group_timeline_actions(actions) {
    var res = [];
    var reply_idx = -1;
    var r_group = [];
    var reply_all_idx = -1;
    var rall_group = [];
    if (actions && typeof actions.forEach == "undefined") {
        actions = [actions];
    } else if (!actions) {
        return [];
    }
    
    actions.forEach((action, idx) => {
        if (action.name == "replymessage") {
            reply_idx = res.length;
            r_group.push(action);
            res.push(r_group);
        } else if (action.name == "replytemplatedmessage") {
            r_group.push(action);
        } else if(action.name == "replyallmessage") {
            reply_all_idx = res.length;
            rall_group.push(action);
            res.push(rall_group);
        } else if (action.name == "replyalltemplatedmessage") {
            rall_group.push(action);
        } else {
            res.push(action);
        }
    });

    if (r_group.length == 1) {
        res[reply_idx] = res[reply_idx][0];
    } else if (reply_idx >= 0) {
        res[reply_idx] = {
            is_group: true,
            icon: "fa-reply",
            colour: "primary",
            items: res[reply_idx]
        }
    }
    if (rall_group.length == 1) {
        res[reply_all_idx] = res[reply_all_idx][0];
    } else if (reply_all_idx >= 0) {
        res[reply_all_idx] = {
            is_group: true,
            icon: "fa-reply-all",
            colour: "primary",
            items: res[reply_all_idx]
        }
    }
    return res;
}

//     return actions.reduce((res, action, idx, array) => {
//         if (action == "replymessage" || action.name == "replytemplatedmessage") {
//             if (res.length && res[res.length-1].length == 1) {
//                 res[res.length-1].append(action);
//             } else if(idx+1 < array.length && (array[idx+1].name == "replymessage" || array[idx+1].name == "replytemplatedmessage")) {
//                 res.push([action]);
//             }
//         } else {
//             res.push(action);
//         }
//         return res;
//     }, [[], []])[0];

// }

function map_timeline_item(cdate, val) {
    var newdate = moment(val.significant_date);
    var type_s = (val.key_code_ss && val.key_code_ss[0]) || val.type_t || "";
    type_s = type_s.toLowerCase();
    val.type =
        _row_templates[type_s] ?
            type_s :
            "base"
            // (val.key_code_ss && _row_templates[val.key_code_ss[0]] ?
            //     val.key_code_ss[0] :
            //     "base"
            // )
            ;
    if (val.type == "timer") {
        val.breached = (val.deadline_date_tdt < val.significant_date) || (val.status_s != "completed" && val.deadline_date_tdt < new Date());
    } else if (val.type == "attachment") {
        if (val.system_text_t) {
            if (val.system_text_t.indexOf("Attachment added:") == 0)
                val.caption = _("timeline_attachment_added", "Attachment Added:");
            else val.caption = val.system_text_t.slice(0, val.system_text_t.indexOf(":")+1);
        }
    }
    var hr = HalResource(val);
    val.actions = ko.observable([]);
    hr.follow_with_cache("uly:actions", uly.api.action_cache).then(function(results) {
        val.actions(group_timeline_actions(results));
    });
    val.is_mine = ko.pureComputed(function() {
        try {
            var pid = ko.unwrap(uly.page.userprofile.unique_id);
        }
        catch(e) {
            pid = null;
        }
        return pid && pid == val.author_id;
    });
    if (!cdate || (newdate.dayOfYear() != cdate.dayOfYear())) {
        cdate = newdate;
        return [cdate, [ {"type": "timemark", "value":newdate.format("ll") }, val]];
    }
    return [cdate, val];
}

ko.bindingHandlers.lineartimeline = {
    "init":function(element, va, allbindings, model, context) {
        function _load_timeline(resource, start, count, show_hidden, show_children, filter, show_facets) {
            var h_res = HalResource(resource);
            var active_facets = ko.unwrap(timeline_model.faceting.active);
            var fq = filter ? [filter] : null;
            if (active_facets) {
                $.each(active_facets, function(idx, facet) {
                    if (facet.selector) {
                        if (fq) { fq.push(facet.selector); }
                        else { fq = [facet.selector]; }
                    }
                });
            }
            var text_f = timeline_model.parameters._search_body();
            if (text_f) {
                if (fq) { fq.push(text_f); }
                else { fq = [text_f]; }
            }
            var timeline = h_res.follow("uly:timeline", {
                "start":start,
                "count":count,
                "show_hidden":show_hidden,
                "show_children": show_children,
                "fq": fq,
                "skip_facets": !show_facets
            }).then(function(collection) {
                timeline_model.total(collection.total);
                update_facets(collection, timeline_model);

                return HalResource(collection).follow("items").then(function(result) {
                    var cdate = null;
                    return $.map(result, function(val) {
                        var res = map_timeline_item(cdate, val);
                        cdate = res[0];
                        return res[1];
                    });
                }, function(error) {
                    console.log("timeline error:", error);
                    return [];
                });
            }, function(error) {
                console.log("timeline error:", error);
                return [];
            });
            return timeline;
        }

        var widget_model = ko.unwrap(allbindings().widget);

        var timeline_model = {
            items: ko.observableArray([]),
            total: ko.observable(0),
            start: ko.observable(0),
            page_size: ko.observable(10),
            show_hidden: ko.observable(allbindings().show_hidden),
            show_children: ko.pureComputed(function() {return ko.unwrap(allbindings().show_children) || false; }),
            global: ko.pureComputed(function() { return ko.unwrap(allbindings().global) || false; }),
            facets_visible: ko.observable(false),
            filter: ko.pureComputed(function() { return ko.unwrap(allbindings().filter) || null; }),
            activeItem: ko.observable(null),
            activate: function(item, ev) {
                if (ev.target.tagName == "A") {
                    return true;
                }
                if (ev.target.parentElement.tagName == "A" && ev.target.parentElement.target == "_blank") {
                    return true;
                }
                if (timeline_model.activeItem() == item) {
                    
                    timeline_model.activeItem(null);
                }
                else
                    timeline_model.activeItem(item);
            },
            show_conversation: function(entry, ev) {
                uly.api.start().follow("uly:data").follow("uly:chatbotmessage", {
                    filters: "conversation_id='" + ko.unwrap((entry.related_id_s || "").split("#")[1]) + "'",
                    fields: ["id","audit_created_on","plain_text","format","content","author_type"],
                    embed: 1
                }).follow("item").then((items) => {
                    var items = items.sort((i1,i2) => 
                    i1.audit_created_on> i2.audit_created_on ? 1 : -1);
                    uly.dialogs.execute($("#chatbot-conversation-tmpl").html(),
                    { 
                        title: _("vwfs_chatbot_conversation_preview_title", "Chatbot Conversation"),
                        raw_data: true
                    },
                     {
                        "messages": items,
                    }).then(()=>{});
                });
            },
            parameters: {
                _search_body: ko.observable(null)
            },
        };
        $.extend(timeline_model, {
            toggle_facets: function() {
                timeline_model.facets_visible(!timeline_model.facets_visible());
                if (timeline_model.facets_visible()) {
                    timeline_model.query();
                }
            },
            filter_interactions: function(v) {
                
                if (v !== true && timeline_model.interactions_filtered()) {
                    var active = timeline_model.faceting.active();
                    active = active.filter(function(n) { 
                        return n.selector != "key_code_ss:document OR key_code_ss:email* OR key_code_ss:phone*"; 
                    });
                    timeline_model.faceting.active(active);
                } else  if (v !== false && !timeline_model.interactions_filtered()){
                    timeline_model.faceting.active.push({ 
                        caption:_("timeline_faceting_active_filter_interactions","Direct interactions"), 
                        selector:"key_code_ss:document OR key_code_ss:email* OR key_code_ss:phone*", name:"inractions", 
                        value:"*", valueCaption:_("timeline_faceting_active_filter_caption_interactions","Interactions")});
                    timeline_model.filter_attachments(false);
                    timeline_model.filter_emails(false);
                    timeline_model.filter_actions_taken(false);
                    timeline_model.filter_notes(false);
                }
                timeline_model.refresh();
            },
            interactions_filtered: ko.pureComputed(function(v) {
                var active = timeline_model.faceting.active();
                var is_filtered = active.filter(function(f) { return f.selector == "key_code_ss:document OR key_code_ss:email* OR key_code_ss:phone*";});
                return is_filtered.length > 0;
            }),
            filter_notes: function(v) {
                if (v !== true && timeline_model.notes_filtered()) {
                    var active = timeline_model.faceting.active();
                    active = active.filter(function(n) { return n.selector != "note_t:*"; });
                    timeline_model.faceting.active(active);
                } else  if (v !== false && !timeline_model.notes_filtered()){
                    timeline_model.faceting.active.push({ 
                        caption:_("timeline_faceting_active_filter_notes","Notes"), 
                        selector:"note_t:*", name:"note_t", 
                        value:"*", valueCaption:_("timeline_faceting_active_filter_caption_notes","Notes")});
                    timeline_model.filter_attachments(false);
                    timeline_model.filter_emails(false);
                    timeline_model.filter_actions_taken(false);
                    timeline_model.filter_interactions(false);
                }
                timeline_model.refresh();
            },
            notes_filtered: ko.pureComputed(function(v) {
                var active = timeline_model.faceting.active();
                var is_filtered = active.filter(function(f) { return f.selector == "note_t:*";});
                return is_filtered.length > 0;
            }),
            filter_system: function(v) {
                const system_selector = "note_t:* OR key_code_ss:attachment OR key_code_ss:email_in OR key_code_ss:email_out OR key_code_ss:document";
                if (v !== true && timeline_model.system_filtered()) {
                    var active = timeline_model.faceting.active();
                    active = active.filter(function(n) { return n.selector != system_selector; });
                    timeline_model.faceting.active(active);
                } else  if (v !== false && !timeline_model.notes_filtered()){
                    timeline_model.faceting.active.push({ 
                        caption:_("timeline_faceting_active_filter_no_system_messages","No System Messages"), 
                        selector:system_selector, name:"nosystem", value:"*", 
                        valueCaption:_("timeline_faceting_active_filter_no_system_messages_caption","No System")});
                }
                timeline_model.refresh();
            },
            system_filtered: ko.pureComputed(function() {
                const system_selector = "note_t:* OR key_code_ss:attachment OR key_code_ss:email_in OR key_code_ss:email_out OR key_code_ss:document";
                var active = timeline_model.faceting.active();
                var is_filtered = active.filter(function(f) { return f.selector == system_selector;});
                return is_filtered.length > 0;
            }),
            filter_attachments: function(v) {
                if (v !== true && timeline_model.attachments_filtered()) {
                    var active = timeline_model.faceting.active();
                    active = active.filter(function(n) { return n.selector != "key_code_ss:attachment"; });
                    timeline_model.faceting.active(active);
                } else  if (v !== false && !timeline_model.attachments_filtered()){
                    timeline_model.faceting.active.push({ 
                        caption:_("timeline_faceting_active_filter_attachments","Attachments"), 
                        selector:"key_code_ss:attachment", 
                        name:"key_code_ss", value:"attachment", 
                        valueCaption:_("timeline_faceting_active_filter_caption_attachments","Attachments")
                    });
                    timeline_model.filter_emails(false);
                    timeline_model.filter_notes(false);
                    timeline_model.filter_actions_taken(false);
                    timeline_model.filter_interactions(false);
                }
                timeline_model.refresh();
            },
            attachments_filtered: ko.pureComputed(function(v) {
                var active = timeline_model.faceting.active();
                var is_filtered = active.filter(function(f) { return f.selector == "key_code_ss:attachment";});
                return is_filtered.length > 0;
            }),
            filter_emails: function(v) {
                if (v !== true && timeline_model.emails_filtered()) {
                    var active = timeline_model.faceting.active();
                    active = active.filter(function(n) { return n.selector != "key_code_ss:email_in OR key_code_ss:email_out"; });
                    timeline_model.faceting.active(active);
                } else if (v !== false && !timeline_model.emails_filtered()) {
                    timeline_model.faceting.active.push({ 
                        caption:_("timeline_faceting_active_filter_emails","Emails"), 
                        selector:"key_code_ss:email_in OR key_code_ss:email_out", name:"key_code_ss", value:"email_in OR email_out", 
                        valueCaption:_("timeline_faceting_active_filter_caption_emails","Emails")
                    });
                    timeline_model.filter_attachments(false);
                    timeline_model.filter_notes(false);
                    timeline_model.filter_actions_taken(false);
                    timeline_model.filter_interactions(false);
                }
                timeline_model.refresh();
            },
            emails_filtered: ko.pureComputed(function() {
                var active = timeline_model.faceting.active();
                var is_filtered = active.filter(function(f) { return f.selector == "key_code_ss:email_in OR key_code_ss:email_out";});
                return is_filtered.length > 0;
            }),
            filter_actions_taken: function(v) {
                if (v !== true && timeline_model.actions_taken_filtered()) {
                    var active = timeline_model.faceting.active();
                    active = active.filter(function(n) { 
                        return n.selector != "key_code_ss:action_taken"; 
                    });
                    timeline_model.faceting.active(active);
                } else if (v !== false && !timeline_model.actions_taken_filtered()) {
                    timeline_model.faceting.active.push({ 
                        caption:_("timeline_faceting_active_filter_actions_taken","Actions Taken"), 
                        selector:"key_code_ss:action_taken", name:"key_code_ss", value:"action_taken", 
                        valueCaption:_("timeline_faceting_active_filter_caption_actions_taken","Actions Taken")
                    });
                    timeline_model.filter_attachments(false);
                    timeline_model.filter_notes(false);
                    timeline_model.filter_emails(false);
                    timeline_model.filter_interactions(false);
                }
                timeline_model.refresh();
            },
            actions_taken_filtered: ko.pureComputed(function() {
                var active = timeline_model.faceting.active();
                var is_filtered = active.filter(function(f) { return f.selector == "key_code_ss:action_taken";});
                return is_filtered.length > 0;
            }),
            faceting: {
                active: ko.observableArray([]),
                widgets: ko.observableArray([]),
                unselectFacet: function(val, ev) {
                    timeline_model.faceting.active.remove(val);
                    timeline_model.refresh();
                }
            },
            next: ko.pureComputed(function() { return timeline_model.total() > timeline_model.start() + timeline_model.page_size(); }),
            prev: ko.pureComputed(function() { return timeline_model.start() > 0; }),
            pager_pages: ko.pureComputed(function() {
                var res = [];
                var page_size = timeline_model.page_size() || 10;
                var tot_pages = Math.floor(timeline_model.total() /  page_size) + 1;
                var cindex = timeline_model.start();
                var cpage = Math.floor(cindex / page_size);

                res.push([1, cindex > 0 ? 0 : "."]);
                if (cpage > 2)
                    res.push(["...", "."]);
                if (cpage > 1)
                    res.push([cpage, (cpage-1) * page_size]);
                if (cpage > 0 && cpage < tot_pages - 1)
                    res.push([cpage+1, "."]);
                if (cpage < tot_pages - 2)
                    res.push([cpage+2, (cpage+1)*page_size]);
                if (cpage < (tot_pages - 3))
                    res.push(["...", "."]);
                res.push([tot_pages, cpage < tot_pages - 1 ? (tot_pages-1)*page_size : "."]);
                return res;
            }),
            need_pager: ko.pureComputed(function() { return timeline_model.total() > timeline_model.page_size(); }),
            "query": function() {
                var resource = ko.unwrap(va());
                if (timeline_model.global()) {
                    resource = uly.page.userprofile;
                }
                return _load_timeline(
                    resource, timeline_model.start(), timeline_model.page_size(), 
                    ko.unwrap(allbindings().show_hidden), ko.unwrap(allbindings().show_children), 
                    ko.unwrap(allbindings().filter),
                    ko.unwrap(timeline_model.facets_visible())
                ).then(function(items) {
                    timeline_model.items(items);
                }, function() { timeline_model.items([]); timeline_model.total(0); });
            },
            "refresh": function() {
                timeline_model.start(0);
                return timeline_model.query();
            },
            "go_prev": function() {
                var next_val = timeline_model.start() - timeline_model.page_size();
                if (next_val < 0)
                    next_val = 0;
                if (next_val != timeline_model.start())
                    timeline_model.start(next_val);
                return timeline_model.query();
            },
            "go_next": function() {
                var next_val = timeline_model.start() + timeline_model.page_size();
                if (next_val > timeline_model.total())
                    return Promise.Deferred().resolve();
                if (next_val < 0)
                    next_val = 0;
                if (next_val != timeline_model.start())
                    timeline_model.start(next_val);
                return timeline_model.query();
            },
            "go_to": function(index) {
                timeline_model.start(index);
                return timeline_model.query();
            }
        });

        //now recall stored state
        var page_state = uly.history.get_state();
        var timeline_state = page_state.data[widget_model.widget_id];
        if (timeline_state) {
            timeline_model.start(timeline_state.start || 0);
            timeline_model.facets_visible(timeline_state.facets_visible || false);
            timeline_model.faceting.active(timeline_state.facets);
        } else {
            var default_mode = ko.unwrap(allbindings().default_mode);
            if (default_mode == "nosystem") {
                timeline_model.filter_system(true);
            } else if (default_mode == "notes") {
                timeline_model.filter_notes(true);
            } else if (default_mode == "files") {
                timeline_model.filter_attachments(true);
            } else if (default_mode == "email") {
                timeline_model.filter_emails(true);
            } else if (default_mode == "actions_taken") {
                timeline_model.filter_actions_taken(true);
            } else if (default_mode == "interactions") {
                timeline_model.filter_interactions(true);
            }
        }
        var childContext = context.createChildContext(timeline_model);
        ko.applyBindingsToDescendants(childContext, element);
        $(element).data("timeline", timeline_model);
        uly.subscribe("entity.modified", timeline_model.refresh, element);
        uly.subscribe("attachments.uploaded", timeline_model.refresh, element);
        uly.subscribe("attachments.deleted", timeline_model.refresh, element);

        uly.subscribe("page.save_state", function(topic, state) {
            state.data[widget_model.widget_id] = {
                "start": timeline_model.start(),
                //TODO "sb": search_model.parameters._search_body(),
                "facets": timeline_model.faceting.active(),
                "facets_visible": timeline_model.facets_visible()
            };
        }, $(element));

        uly.subscribe("timeline.inserted", function(topic, item) {
            var resource = ko.unwrap(va());
            if (!resource) {
                return;
            }
            if (item.entity_id !== resource.unique_id)
                return;
            if (timeline_model.start() <= 8) {
                var res = map_timeline_item(null, item)[1];
                if (Array.isArray(res)) {
                    res.reverse().forEach(function(r) { timeline_model.items.splice(0,0,r); });
                    timeline_model.total(timeline_model.total() + res.length);
                } else {
                    timeline_model.items.splice(0,0,res);
                    timeline_model.total(timeline_model.total() + 1);
                }
            }
        }, element);
        let _sub = timeline_model.parameters._search_body.subscribe(function() { timeline_model.start(0); timeline_model.refresh(); });
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            _sub.dispose();
            _sub = null;
        });

        return { "controlsDescendantBindings": true };
    },
    update: function(elt, va) {
        var resource = ko.unwrap(va());
        var timeline_model = $(elt).data("timeline");
        uly.utils.throttle(elt, function() { timeline_model.query(); }, 500);
    }
};
